import { JobCategory } from "@/api/generated";
import { AccountRegisterFormData } from "@/validations/account";

type Field = keyof AccountRegisterFormData;
export type AccountFormStep = "birth" | "residence" | "job" | "assets" | "interest" | "reason";
export const getAccountStepFields = (step: AccountFormStep, values: Partial<AccountRegisterFormData>): Field[] => {
  switch (step) {
    case "birth":
      return ["family_name", "first_name", "family_name_kana", "first_name_kana", "birth_year", "birth_month"];
    case "residence":
      return [
        "address_prefecture",
        "current_residence_type_id",
        ...(values.current_residence_type_id === 1
          ? ["home_loan_amount" as Field]
          : values.current_residence_type_id === 2
            ? ["monthly_rent_payment_amount" as Field]
            : []),
      ];
    case "job":
      return [
        "job_category",
        "job_continuous_period",
        "annual_income",
        ...([JobCategory.会社員上場, JobCategory.会社員非上場, JobCategory.会社員外資系企業].includes(
          values.job_category as JobCategory
        )
          ? ["job_industry" as Field]
          : []),
      ];
    case "assets":
      return ["financial_asset", "holding_property_count", "real_estate_loan_amount"];
    case "interest":
      return ["has_investment_experience", "interested_property_type_ids"];
    case "reason":
      return [
        "purpose_of_use_ids",
        ...(values.purpose_of_use_ids?.includes(6) ? ["purpose_of_use_free_text" as Field] : []),
        "other_request_text",
      ];
  }
};

export const focusFirstRegistrationError = () => {
  window.setTimeout(() => {
    const field = document.querySelector<HTMLElement>("[data-registration-flow] [aria-invalid=\"true\"]");
    field?.scrollIntoView?.({ block: "center", behavior: "smooth" });
    field?.focus();
  }, 0);
};
